import { render } from "./company-patent-details.vue?vue&type=template&id=9eff6292&scoped=true"
import script from "./company-patent-details.vue?vue&type=script&lang=js"
export * from "./company-patent-details.vue?vue&type=script&lang=js"

import "./company-patent-details.vue?vue&type=style&index=0&id=9eff6292&scoped=scoped&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eff6292"]])

export default __exports__